import { useState, useContext, useEffect, useRef} from "react";
import { useNavigate } from "react-router-dom";
import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
// import debounce from 'lodash/debounce';
// import { useMemo } from 'react';

import authAxios from "../../components/authAxios";

import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

// import { InputAdornment } from '@mui/material';
// import { CircularProgress } from '@mui/material';
// import { InputAdornment } from '@mui/material';
// import NumberFormat from "react-number-format";

import moment from 'moment';

//ANT DESIGN STEPS
import { Steps, Button, Radio } from 'antd';

import UserAlerts from "../../components/UserAlerts";
import DashboardHeader from "../../components/DashboardHeader";
import { UserContext } from "../../App";
import { extractErrorMessage } from "../../components/errorUtils";
import useDebounce from "../../components/useDebounce";

import './Rentals.css'
import Loading from "../../components/Loading";
// import ProductDetails from "../products/ProductDetails";
import LeaseProducts from "./LeaseProducts";

function LeaseNew() {
    const {page_size} = useContext(UserContext);
    // const {pageSize} = useContext(UserContext);

    const queryClient = useQueryClient();
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const errorRef = useRef(null);

    const [searchText, setSearchText] = useState('');
    const debouncedSearchText = useDebounce(searchText, 500);

    const tag = "LEASE"

    const [dashboardTitle, setDashboardTitle] = useState('Add Lease');

    const { data: leaseReference } = useQuery({
        queryKey: ['leaseReference'],
        queryFn: async () => {
            const response = await authAxios.get(`/saas/default-reference/?tag=${tag}`);
            return response.data
        },
    });


    const { data: properties } = useQuery({
        queryKey: ['properties'],
        queryFn: async () => {
            const response = await authAxios.get(`/rentals/properties/?page_size=${page_size}`);
        return response.data.results;
        },
    });

    const [property, setProperty] = useState('');
    // const [unit, setUnit] = useState('');
    const [propertyUnit, setPropertyUnit] = useState('');
    const [tenant, setTenant] = useState(null);


    const { data: units, refetch: refetchUnits } = useQuery({
        queryKey: ['units', property],
        queryFn: async () => {
          if (property) {
            const response = await authAxios.get(`/rentals/property-units/vacant?property=${property}`);
            return response.data;
          }
          return [];
        },
        enabled: !!property, // Fetch units only when property is selected
    });

    const { data: customers, isFetching, isLoading } = useQuery({ // IMPORTANT NOTE: Different use cases for isFetching and isLoading
        queryKey: ['customers', debouncedSearchText],
        queryFn: async () => {
          const response = await authAxios.get("/crm/customer-contacts", {params: {search: debouncedSearchText}});
          return response.data
        },
        enabled: !!debouncedSearchText.trim(),
        keepPreviousData: true,
        initialData: []
    });

    const { data: billingCycles } = useQuery({
        queryKey: ['billingCycles'],
        queryFn: async () => {
          const response = await authAxios.get("/subscriptions/billing-cycles");
          return response.data
        },
    });

    // const { data: products } = useQuery({
    //     queryKey: ['products'],
    //     queryFn: async () => {            
    //         const response = await authAxios.get(`/inventory/items/?&property=${property}&page_size=${pageSize}`);
    //         return response.data.results;
    //     },
    //     enabled: !!property 
    // });
    
    const [isModalOpen, setIsModalOpen] = useState(false);


    // const [product, setProduct] = useState("");

    // const [dt, setDt] = useState(new Date());
    const [dt, setDt] = useState(null);
    const [dt1, setDt1] = useState(null);
    const [dt2, setDt2] = useState(moment())

    // const [property_name, setPropertyName] = useState('');
    const [billingCycle, setBillingCycle] = useState('');
    const [billingInterval, setBillingInterval] = useState(1);

    const [billingType, setBillingType] = useState('010');
    const [leaseType, setLeaseType] = useState('RESIDENTIAL');

    const user = localStorage.getItem('userID');
    const client = localStorage.getItem('clientID');
    // const [memo, setMemo] = useState('');
    // const [price, setPrice] = useState('');
    const [leaseProducts, setLeaseProducts] = useState([]);


    const { Step } = Steps;
    // const { Item } = Form;
    const [currentStep, setCurrentStep] = useState(0);

   
    const nextStep = () => {
      setCurrentStep(currentStep + 1);
    };
  
    const prevStep = () => {
      setCurrentStep(currentStep - 1);
    };

    // const addTxnLine = (newTxnLine) => {
    //     setTxnLines([...txnLines, newTxnLine]);
    //     setIsModalOpen(false); // Close the modal after adding the expense
    // };

    const handleUnitSelection = (e) => {
        // setUnit(e)
        setPropertyUnit(e)

        // try {
        //     const p = products.find((product) => product.sku === e.sku_reference)
        //     setProduct(p)
        //     setPrice(p.price_data.price)
        // }
        // catch (error){
        //     console.log(error)
        // }
    }

    // const handleConfirmedPrice = (e) => {
    //     const amt = parseFloat(e.target.value.replace(/,/g, ''));
    //     setPrice(amt)
    // }

    const mutation = useMutation({
        mutationFn: (lease) => {
            // return authAxios.post("/subscriptions/subscriptions/", lease);
            return authAxios.post("/rentals/leases/", lease);

        },
        onError: (error, variables, context) => {
            console.log("ERROR",error)
            const errorMessage = extractErrorMessage(error.response?.data) || error.message;
            setError(errorMessage);
        },
        onSuccess: (result) => {
            queryClient.invalidateQueries(['leases']);
            navigate('/dashboard/leases/');
        },
      })



    const handleSubmit = (e) => {
        e.preventDefault();
            
            const start_date = moment(dt).format("YYYY-MM-DD")
            const end_date = moment(dt1).format("YYYY-MM-DD")

            let next_billing_time = moment(dt2).format("YYYY-MM-DD")
            const currentDate = moment();
            if (moment(dt2).isAfter(currentDate, 'day')) {
                next_billing_time = moment(dt2)
                    .hours(12)
                    .minutes(0)
                    .seconds(0)
                    .milliseconds(0)
                    .format("YYYY-MM-DD HH:mm:ss");
            }
         
            const billing_cycle = billingCycle
            const billing_interval = billingInterval
            const billing_type = billingType
            

            // let txn_lines = []
            // const newTxnLine = {
            //     product: product.product,
            //     sku:product.sku,
            //     quantity:1,
            //     price: price,
            //     sub_total: price,
            //     total: price,
            // };

            // txn_lines = [...txn_lines, newTxnLine];
            const lease_products = leaseProducts

            const reference = leaseReference
            const customer = tenant.id
            const property_unit = propertyUnit.id
            const lease_type = leaseType

            const lease = {client, reference, customer, property, property_unit, lease_type, lease_products, start_date, end_date, billing_type, billing_cycle, billing_interval, next_billing_time, user };
            console.log("LEASE",lease)
            mutation.mutate(lease)    
    }


    useEffect(()=>{
        if (error){
            errorRef.current.scrollIntoView();  
        }            
    },[error])

    if (isLoading) return <Loading loading={true} />;


    return(
        <div className="dashboard-main">
            <section className="dashboard-content">
                <section className="dashboard-form dashboard-form-compact">
                    <div ref={errorRef}>
                        <UserAlerts error={error}  />
                    </div>
                    <DashboardHeader dashboardTitle={dashboardTitle} dashboardPreTitle="Rentals" />

                    <div className="lease-new">

                        <Steps size="small" current={currentStep}>
                            <Step title="Property" />
                            <Step title="Products" />
                            <Step title="Dates" />
                            <Step title="Billing" />
                        </Steps>
                    
                        <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                            {currentStep === 0 && (
                            <>
                                <Autocomplete
                                    value={tenant}
                                    onChange={(event, newValue) => setTenant(newValue)}
                                    inputValue={searchText}
                                    onInputChange={(event, newInput) => setSearchText(newInput)}
                                    options={customers || []}
                                    getOptionLabel={(option) => { return option ? option.name : '' }} // Ensure option is not null or undefined
                                    isOptionEqualToValue={(option, value) => //IMPORTANT: This is the magic
                                        option.id === value.id
                                    }

                                    noOptionsText={
                                        searchText.trim().length < 1
                                            ? 'Enter search text'
                                            : isFetching
                                            ? 'Loading…'
                                            : 'No matches found. Please try a different search'
                                    }

                                    renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Tenant" />}
                                />

                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        setProperty(newValue.id);
                                    }}
                                    options={properties || []}
                                    getOptionLabel={(option) => { return option ? option.name : '' }} // Ensure option is not null or undefined
                                    renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Property" />}
                                />

                                <Autocomplete
                                    onChange={(event, newValue) => handleUnitSelection(newValue)}
                                    options={units || []}
                                    getOptionLabel={(option) => {
                                        return option ? option.reference : ''; // Ensure option is not null or undefined
                                    }}
                                    renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Unit" />}
                                    disabled={!property} // Disable unit selection until property is selected
                                />

                                {/* <NumberFormat 
                                    value={price}
                                    onChange={(e) => handleConfirmedPrice(e)} 
                                    className="custom-input"
                                    fullWidth
                                    label="Price" 
                                    variant="outlined" 
                                    customInput={TextField}
                                    thousandSeparator={true} 
                                /> */}

                                <Radio.Group
                                    onChange={(e) => setLeaseType(e.target.value)}
                                    className="custom-input"
                                    value={leaseType}
                                >
                                    <Radio value='RESIDENTIAL'>Residential</Radio>
                                    <Radio value='COMMERCIAL'>Commercial</Radio>
                                </Radio.Group>
                            </>
                            )}

                            {currentStep === 1 && (
                            <>
                                <LeaseProducts 
                                    // addTxnLine={addTxnLine}
                                    // txnLines={txnLines} 
                                    // setTxnLines={setTxnLines} 
                                    leaseProducts={leaseProducts}
                                    setLeaseProducts={setLeaseProducts}
                                    isModalOpen={isModalOpen}
                                    setIsModalOpen={setIsModalOpen}
                                />
                            </>
                            )}

                            {currentStep === 2 && (
                            <>
                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                    <DesktopDatePicker
                                        label="Start Date"
                                        value={dt}
                                        onChange={(newDate) => {
                                            setDt(moment(newDate).format("YYYY-MM-DD"));

                                        }}
                                        renderInput={(params) => <TextField fullWidth required className="custom-input" {...params} />}
                                    />
                                </LocalizationProvider>

                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                    <DesktopDatePicker
                                        label="End Date"
                                        value={dt1}
                                        onChange={(newDate) => {
                                            setDt1(moment(newDate).format("YYYY-MM-DD"));

                                        }}
                                        renderInput={(params) => <TextField fullWidth required className="custom-input" {...params} />}
                                    />
                                </LocalizationProvider>
                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                    <DesktopDatePicker
                                        label="First Billing Date"
                                        value={dt2}
                                        onChange={(newDate) => {
                                            setDt2(moment(newDate).format("YYYY-MM-DD"));
                                        }}
                                        renderInput={(params) => <TextField fullWidth required className="custom-input" {...params} />}
                                    />
                                </LocalizationProvider>
                            </>
                            )}
                             
                            {currentStep === 3 && (
                            <>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        setBillingCycle(newValue.id);
                                    }}
                                    options={billingCycles || []}
                                    getOptionLabel={(option) => { return option ? option.name : '' }} // Ensure option is not null or undefined
                                    renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Billing Cycle" />}
                                    value={billingCycle !== null && billingCycles? billingCycles.find((option) => option.id === billingCycle) : null }
                                />
                             
                                <Radio.Group
                                    onChange={(e) => setBillingType(e.target.value)}
                                    className="custom-input"
                                >
                                    <Radio value='010'>Advance</Radio>
                                    <Radio value='020'>Arrears</Radio>
                                </Radio.Group>
                               
                            </>
                            )}

                            <div className="button-border-top">
                                {currentStep > 0 && (
                                    <Button type="default" onClick={prevStep}>
                                        Previous
                                    </Button>
                                )}
                                {currentStep < 3 && (
                                    <Button type="primary" onClick={nextStep}>
                                        Next
                                    </Button>
                                )}
                                {currentStep === 3 && (
                                    <Button 
                                        type="primary" 
                                        htmlType="submit"
                                        loading={mutation.isLoading}
                                    >
                                        Save
                                    </Button>
                                )}
                            </div>
                        </form> 

                    </div>
                </section>
            </section> 

        </div>
    )
}

export default LeaseNew;
